
import {ProfileMenuModel } from '../models/ProfileMenuModel.js';
import {ProfileMenuView } from '../views/ProfileMenuView.js';

export class ProfileMenuController {
    constructor() {

        this.model = new ProfileMenuModel();
        this.view = new ProfileMenuView();

        this.model.subscribe(state => this.view.render(state));
    }
}